//-- Preloader

window.onload = function() {
    let loader = document.querySelector('.preloader');
    loader.remove();
};

//-- End Preloader

$(document).ready(function () {
    var nHelper = $(".helper"),
        nExpand = $("[data-expand]"),
        WIN = $(window),
        DOC = $(document),
        scrollTo = null,
        isMacLike = /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform),
        isIOS = /(iPhone|iPod|iPad)/i.test(navigator.platform);

    var mainSlider = new Swiper ('[data-slider-main]', {
        loop: true,
        autoplay: {
            delay: 2000,
            disableOnInteraction: false
        },
        pagination: {
            el: '.swiper-pagination',
            clickable: true
        }
    });

    var winnersSlider = new Swiper ('[data-slider-winners]', {
        loop: true,
        slidesPerView: 3,
        direction: 'vertical',
        loopedSlides: 12,
        autoplay: {
            delay: 2500
        },
    });

    $('.currency__select').click(function(){
        $(this).toggleClass('open');

    });

    $('.currency__select li').click(function(){
        $('ul li').removeClass('currency__active');
        $(this).toggleClass('currency__active');

    });

    /**
     * Инициализация поля выбора даты
     * Используется в формах, которые подгружаются на ajax
     * Для этого вынесен в функцию для использования внутри ajaxSuccess
     **/
    function dateInit() {
        var input_date = $('[data-datepicker]');
        if (input_date.length > 0 && input_date.is(':visible')) {
            if (!$('.datepickers-container').length) {
                var date = (new Date()).getFullYear(),
                    maxdate = new Date();
                maxdate.setYear(date - 18);

                input_date.datepicker({
                    maxDate: maxdate,
                    autoClose: true,
                    dateFormat: 'yyyy-mm-dd',
                    language: $('html').attr('lang')
                });
            }
        }
    }

    dateInit();

	//-- Mobile tables
	$('table').each(function () {
		if($(this).parent('').hasClass('table')){
			(function() {
				var headertext = [];
				var headers = document.querySelectorAll(".table thead");
				var tablebody = document.querySelectorAll(".table tbody");

				for (var i = 0; i < headers.length; i++) {
					headertext[i] = [];
					for (var j = 0, headrow; headrow = headers[i].rows[0].cells[j]; j++) {
						var current = headrow;
						headertext[i].push(current.textContent.replace(/\r?\n|\r/, ""));
					}
				}
				if (headers.length > 0) {
					for (var h = 0, tbody; tbody = tablebody[h]; h++) {
						for (var i = 0, row; row = tbody.rows[i]; i++) {
							for (var j = 0, col; col = row.cells[j]; j++) {
								col.setAttribute("data-label", headertext[h][j]);
							}
						}
					}
				}
			}());
		}
	})
	//-- End Mobile tables

    $('[data-game-info-button]').on('click', function() {
        var gameInfo = $('[data-game-info]');
        var footer = $(".footer__lobby");
        footer.slideToggle();
        // gameInfo.toggleClass("displayed");
        gameInfo.slideToggle('slow',  'linear');
        if(gameInfo.is(':visible')){
            $('html, body').animate({
                scrollTop: $("div.game__info__more").offset().top
            }, 1000)
        }
    });

    // --- primary mobile menu: open stuff -------------------------------------
    $('[data-menu-toggler]').click(function() {
        $(this).addClass("on");
        $('[data-menu-mobile]').addClass('open');
        $('body').addClass('fixed');
        $('header').addClass('open');
        $('.main').addClass('open');
        $('footer').addClass('open');
        return false;
    });

    // --- close primary mobile menu by 3 ways:---------------------------------
    // click on 'close' button
    DOC.on('click', '[data-mobile-menu-close]', function(){
        $('[data-menu-toggler]').removeClass("on");
        $('[data-menu-mobile]').removeClass('open');
        $('body').removeClass('fixed');
        $('header').removeClass('open');
        $('.main').removeClass('open');
        $('footer').removeClass('open');
    });
    // click outside of menu
    $(document).click(function(event) {
      if(!$(event.target).closest('[data-menu-mobile]').length == 0) {
        $('[data-menu-toggler]').removeClass("on");
        $('[data-menu-mobile]').removeClass('open');
        $('body').removeClass('fixed');
        $('header').removeClass('open');
        $('.main').removeClass('open');
        $('footer').removeClass('open');
      }
    });
    // window resize
    $(window).on('resize', function() {
      $('[data-menu-toggler]').removeClass("on");
      $('[data-menu-mobile]').removeClass('open');
      $('body').removeClass('fixed');
      $('header').removeClass('open');
      $('.main').removeClass('open');
      $('footer').removeClass('open');
    });
    // --- end mobile menu stuff -----------------------------------------------


    /** Tabs + cookie / profile: bonuses player page -------------- **/
    function bonusesSwitcher(e) {
        const bonusesActive = $('[data-bonuses-active]');
        const bonusesActiveContent = $('[data-bonuses-active-content]');

        const bonusesAvailable = $('[data-bonuses-available]');
        const bonusesAvailableContent = $('[data-bonuses-available-content]');

        bonusesAvailable.on('click', function() {
            bonusesActive.removeClass('active');
            bonusesActiveContent.removeClass('active');
            bonusesAvailable.addClass('active');
            bonusesAvailableContent.addClass('active');
            $.cookie('BonusesSwitcher', 'bonuses-available', {
                path: '/'
            });
            lazyLoad();
        });

        bonusesActive.on('click', function() {
            bonusesAvailable.removeClass('active');
            bonusesAvailableContent.removeClass('active');
            bonusesActive.addClass('active');
            bonusesActiveContent.addClass('active');
            $.cookie('BonusesSwitcher', 'bonuses-active', {
                path: '/'
            });
            lazyLoad();
        });
    }

    bonusesSwitcher();
    /** End Tabs profile bonuses **/

    /** ADD cookies profile bonuses switcher **/
    function setBonusesView() {
        if ($.cookie('BonusesSwitcher') == null) {
            $.cookie('BonusesSwitcher', 'bonuses-available', {
                path: '/'
            });
        }

        setTimeout(function() {
            if ($.cookie('BonusesSwitcher') == 'bonuses-available') {
                $('[data-bonuses-available]').click();
            }
        }, 100);

        setTimeout(function() {
            if ($.cookie('BonusesSwitcher') == 'bonuses-active') {
                $('[data-bonuses-active]').click();
            }
        }, 100);

    }

    setBonusesView();
    /** END ADD cookies profile bonuses switcher **/


    function checkMobile(element, wrapper, holder, type) {
        if (WIN.width() < 768){
            return type ? element.appendTo(wrapper) : element.prependTo(wrapper);
        } else {
            return type ? element.appendTo(holder) : element.prependTo(holder);
        }
    }

    function preventScroll() {
        $("body").bind('mousewheel DOMMouseScroll touchmove', function (event) {

            if (event.type == 'mousewheel') {
                scrollTo = (event.originalEvent.wheelDelta * -1);
            }

            else if (event.type == 'DOMMouseScroll') {
                scrollTo = 40 * event.originalEvent.detail;
            }

            if (scrollTo) {
                event.preventDefault();
                $(this).scrollTop(scrollTo + $(this).scrollTop());
            }

            return false;
        });
    }

    /** Инициализация типовых модалок **/
    $('[data-modal]').magnificPopup({
        type: 'ajax',
        removalDelay: 100,
        mainClass: 'mfp-zoom-in',
        tLoading: '',
        callbacks: {
            parseAjax: function(mfpResponse) {
                mfpResponse.data = "<div class='wrapping'>" + mfpResponse.data + "</div>";
            },
            ajaxContentAdded: function() {
                this.content;
            },
            open: function() {
                $('.header').css('width', 'calc(100% - ' + scrollWidth + 'px)')
            },
            close: function() {
                $('.header').css('width', '100%')
            },
            beforeOpen: function() {
                $('body').addClass('blur');
            },
            beforeClose: function() {
                $('body').removeClass('blur');
            }
        }
    });
    /** End Инициализация модалок **/



    // DOC.on('click', '.mfp-content .popup--bonus .button', function(){
    //    $.magnificPopup.close();
    // });

    function scrollbarSize() {
        var scrollDiv = document.createElement("div"),
            scrollbarSize;
        scrollDiv.style.cssText = 'width: 99px; height: 99px; overflow: scroll; position: absolute; top: -9999px;';
        document.body.appendChild(scrollDiv);
        scrollbarSize = scrollDiv.offsetWidth - scrollDiv.clientWidth;
        document.body.removeChild(scrollDiv);

        return scrollbarSize;
    }

    /**
     * Появление и скрытие поля с ответом на секретный вопрос
     **/
    var secret_question = $('.secret_question'),
        secret_answer = $('.secret_answer');
    if (!secret_question.val()) {
        secret_answer.hide();
    }

    function selectInit(){
        $('[data-select-menu]').each(function () {
            if (!$(this).parent().hasClass('selectric-hide-select')) {
                $(this).selectric({
                    maxHeight: 200,
                    disableOnMobile: false,
                    nativeOnMobile: false,
                    onInit: function() {
                        var current_option = $(this),
                            current_option_value = current_option.val(),
                            selectric_container = $(this).parents('.selectric-wrapper').find('.selectric');

                        // проверка для вывода поля с секретным ответом
                        if(current_option.hasClass('secret_question')){
                            if (current_option_value) {
                                secret_answer.show();
                            } else {
                                secret_answer.hide();
                            }
                        }

                        //  эмуляция placeholder'a для селектрика
                        if (current_option_value) {
                            selectric_container.removeClass('selectric--placeholder');
                        } else {
                            selectric_container.addClass('selectric--placeholder');
                        }

                        // проверка на количество эллементов, если 1 - то добавляем класс,
                        // который скрывает всю навигацию
                        if(current_option.find('option').length === 1){
                            current_option.parents('.selectric-wrapper').addClass('selectric--void');
                        }
                    },
                    onChange: function() {
                        var current_option = $(this),
                            current_option_value = current_option.val(),
                            selectric_container = $(this).parents('.selectric-wrapper').find('.selectric');

                        // проверка для вывода поля с секретным ответом
                        if(current_option.hasClass('secret_question')){
                            if (current_option_value) {
                                secret_answer.show();
                            } else {
                                secret_answer.hide();
                            }
                        }

                        //  эмуляция placeholder'a для селектрика
                        if (current_option_value) {
                            selectric_container.removeClass('selectric--placeholder');
                        } else {
                            selectric_container.addClass('selectric--placeholder');
                        }
                    },
                });
            }
        });
    }

    selectInit();

    DOC.on('ajaxSuccess', function () {
        selectInit();
        dateInit();
    });

    /**
     * Событие копирования в буфер обмена при клике на кнопку
     **/
    DOC.on('click', '[data-wallet-copy]', function() {
        $('[data-wallet]').select();
        document.execCommand("copy");
    });

    $('[data-select-currency]').selectric({
        disableOnMobile: false,
        nativeOnMobile: false,
        onInit: function() {
            if($(this).find('option').length === 1){
                $(this).parents('.selectric-wrapper').addClass('selectric--void');
            }
        }
        }).on('change', function() {
        location.href = $(this).val();
    });

    $(document).on('click', '.pager__item a', function(event) {
        $('html, body').animate({
            scrollTop: $('#table-top').offset().top
        }, 500);
    });

    WIN.on('scroll', function(){
        if($(window).scrollTop() + $(window).height() >= $(document).height() - 350){
            var btn = $('.pager__item--load-more');
            if(!btn.hasClass('pager--process')){
                btn.find('a').click();
                btn.addClass('pager--process');
            }
        }
    });


    //-- Рейтинг игры на странице Demo game
    var rating = $('[data-rating]');
    var isLogged = rating.data('logged') ? true : false;


    rating.rating({
        fx: 'half',
        image: '/front/img/stars.png',
        loader: '/front/img/ajax-loader.gif',
        readOnly: isLogged
    });
    if(isLogged){
        $('.vote-hover').css({
            'cursor':'default'
        });
    }
    //-- End Рейтинг игры на странице Demo game


    /* Fix Hover on mobile*/

    fixHover('.games__item', '.games__item__overlay', 'games__item__overlay--active');

    function fixHover(sSelestor, sHover, sActiveClass) {
        $(sSelestor).hover(
            function() {
                $(this)
                    .find(sHover)
                    .addClass(sActiveClass);
            },
            function() {
                $(this)
                    .find(sHover)
                    .removeClass(sActiveClass);
            }
        );
    }

    // функция инициализации выбора кода стран
    function phoneinit() {
        var phone_input = $('[data-profile-phone]');

        if (phone_input.length > 0) {
            if (!$('.intl-tel-input').length) {
                // var input = document.querySelector('input[type="tel"]');

                phone_input.intlTelInput({
                    initialCountry: "auto",
                    autoHideDialCode: true,
                    nationalMode: false,
                    autoPlaceholder: 'off',
	                preferredCountries: ["ua", "ru"],
                    geoIpLookup: function(callback) {
                        $.get("https://ipinfo.io", function() {}, "jsonp").always(function(resp) {
                            var countryCode = (resp && resp.country) ? resp.country : "";
                            callback(countryCode);
                        });
                    },
                    separateDialCode: false,
                    utilsScript: "/front/js/utils.js"
                });
                /**
                 * Запрет на ввод любых символов, кроме цифр и плюса
                 **/
                phone_input.on('change paste keyup', function () {
                    phone_input.val(
                        phone_input.val().replace(/[^\+\d*]+/g, '')
                    );
                });
            }
        }
    }
    //------------

    //-- Инициализация поля выбора телефона в профайле и в регистрации
    phoneinit();
    //------------

    // Инициализация скриптов, структура которых загружается через ajax
    $(document).on('ajaxSuccess', function () {
        phoneinit();
    });
    //------------


    var readURL = function(input) {
        if (input.files && input.files[0]) {
            var reader = new FileReader();

            reader.onload = function (e) {
                $('.profile-pic').attr('src', e.target.result);
            };

            reader.readAsDataURL(input.files[0]);
        }
    };

    $('#avatar-form').submit(function(){
        readURL($('#avatar-input'));
    });

    $(".upload-button").on('click', function() {
        $(".file-upload").click();
    });

    $('ul.tabs__caption').on('click', 'li:not(.active)', function () {
        $(this).addClass('active').siblings().removeClass('active').closest('div.page__profile__content').find('div.tabs__content').removeClass('active').eq($(this).index()).addClass('active');
    });

    function ticketToggle(toggle) {
        if (toggle){
            nTicketFilter.animate({"opacity" : 0}, 200, function () {
                nTicket.fadeIn(200);
            });
        } else {
            nTicket.fadeOut(200, function () {
                nTicketFilter.animate({"opacity" : 1}, 200);
            });
        }
    }
    $('.lang-select').click(function(){
        $(this).toggleClass('open');

    });

    $('.lang-select li').click(function(){
        $('ul li').removeClass('active');
        $(this).toggleClass('active');
    });

    var telInput = $('[data-profile-phone]'),
        errorMsg = $("#error-msg"),
        validMsg = $("#valid-msg");

    var reset = function() {
        telInput.removeClass("error");
        errorMsg.addClass("hide");
        validMsg.addClass("hide");
    };

    // on blur: validate
    telInput.blur(function() {
        reset();
        if ($.trim(telInput.val())) {
            if (telInput.intlTelInput("isValidNumber")) {
                validMsg.removeClass("hide");
            } else {
                telInput.addClass("error");
                errorMsg.removeClass("hide");
            }
        }
    });

    // on keyup / change flag: reset
    telInput.on("keyup change", reset);

    function moveDom(element) {
        $(element).responsiveDom({
            appendTo: element.replace("]", "-holder]"),
            mediaQuery: "(max-width: 1024px)"
        });
    }
    moveDom("[data-backlink]");
    //moveDom("[data-menu]");
    // moveDom("[data-username]");
    // moveDom("[data-currency]");

    function moveDom1(element) {
        $(element).responsiveDom({
            appendTo: element.replace("]", "-holder]"),
            mediaQuery: "(max-width: 700px)"
        });
    }
    moveDom1("[data-take]");
    moveDom1("[data-currency]");
    // moveDom1("[data-reg]");

    $('.editable-box iframe').each(function (){
        $(this).wrap('<div class="videowrapper">');
    });

    $(window).on("orientationchange", function(e){
        $('.table td').css('font-size', '14.1px');

        setTimeout(function() {
            $('.table td').css('font-size', '13px');
        }, 100);
    });

    if (isMacLike) {
        $("html").addClass("apple");
    }
    if (isIOS) {
        $("html").addClass("ios");
    }
    var ua = window.navigator.userAgent;
    var edge = ua.indexOf('Edge/');
    if (edge > 0) {
        $("html").addClass("ie"); //-- to block with IE used same classes
    }
    if(ua.indexOf('Trident/7.0') + 1){
        $("html").addClass("ie");
    }
    if(ua.indexOf('Puffin') + 1){
        $("html").addClass("puffin");
    }

    if (/Android/i.test(navigator.userAgent)) {
        $("html").addClass("android");
    }

    if(!isIOS){
        //$('[data-datepicker]').addClass('input--date');
        $('.form--profile input').attr('disable', 'disable');
        $('.form--profile input').attr('readonly', 'readonly');
        $('.form--profile input.phone_number_field').removeAttr('readonly');
        $('.form--profile input').on('focusin', function(){
            // if(!$(this).hasClass('input--date')){
            //     $(this).removeAttr('readonly');
            // }
            $(this).removeAttr('readonly');
            $(this).removeAttr('disable');
        });
        $('.form--profile input').on('focusout', function(){
            $(this).attr('disable', 'disable');
            $(this).attr('readonly', 'readonly');
            $('.form--profile input.phone_number_field').removeAttr('readonly');
        });
    }

    // IE11 and Edge message
    if($('html').hasClass('ie')){
        $('.ieOff').show();
        $('.helper').remove();
    } else {
        $('.ieOff').remove();
    }
    // end IE11 and Edge message

    /**
     * Событие смены видимости пароля в инпуте
     */
    var passwordToggler = ('[data-password-toggler]');

    DOC.on('click', passwordToggler, function() {
        var btn = $(this),
            input = btn.siblings('input');

        btn.toggleClass('icon-view');
        btn.toggleClass('icon-hide');
        if(input.attr('type') == 'text'){
            input.attr('type', 'password');
        }
        else{
            input.attr('type', 'text');
        }
    });

    /* ------------------------------------------------------------------------ */
    /** обрезка текстовых привью (количество символов береться из дата атрибута) **/
    function dataCutText() {
        var shortText= $('[data-cut-text]');
        shortText.each(function(){
            var size = $(this).data('cutText'),
                elementText = $.trim($(this).text());
            if(elementText.length > size){
                $(this).text(elementText.slice(0, size) + ' ...');
            }
        });
    }

    dataCutText();
    /* ------------------------------------------------------------------------ */


    /** Иниализация отложенной подгрузки изображений + замена битого изображения логотипом проекта */
    function lazyLoad() {
        $('[data-lazy] img[data-src]').Lazy({
            scrollDirection: 'vertical',
            effect: "fadeIn",
            effectTime: 1000,
            // threshold: 0,
            // visibleOnly: false,
            onError: function(element) {
                element.attr("src","../img/logos/logo.png").parent().addClass('no-photo');
            }
        });
    }

    $(document).on('ajaxSuccess', function() {
        lazyLoad();
    });

    /** End **/


	/** Слайдер выбора бонуса на депозит в модалке **/
	function chooseBonus() {
		$('[data-choose-bonus-slider]').each(function() {
			let name = $(this);
			if (name.length > 0 && name.is(':visible') && name.find('.swiper-slide-active').length < 1) {
				// используемые классы
				let chooseSlider = new Swiper(name.find('.swiper-container'), {
					slideClass: 'bonuses__item',
					slidesPerView: 1,
					slidesPerGroup: 1,
					spaceBetween: 0,
					pagination: {
						el: name.find ('.swiper-pagination'),
						clickable: true
					},
					navigation: {
						nextEl: name.find(' .slider-arrow--next'),
						prevEl: name.find(' .slider-arrow--prev'),
					}
				});
			}

		});
	}
	chooseBonus();

	/** Событие срабатывает в случае успешного выполнения ajax запроса **/
	$(document).on('ajaxSuccess', function() {
		chooseBonus();
	});

    /**
     *  Табы в виде трансформера из табов в селекты
     *
     *    data-tabs - аттрибут, по которому происходит инициализация работы табов
     *
     *    data-tabs-save - аттрибут, который, фактически активирует сохранение активного таба в LocalStorage
     *        Для него нужно указать имя, которое будет использоваться для идентификации текущей страницы
     *
     *    data-tabs-sync - аттрибут, который активирует синхронизацию двух табов
     *        Его нужно задать для того селекта, С КОТОРЫМ нужно синхронизировать активный
     *        Если задать для обоих селектов - синхронизация будет работать в обе стороны
     *
     *    data-tabs-transform - аттрибут, значение в котороым указывает ширину экрана, меньше которой табы будут трансформироваться в селект
     *
     *    data-tabs-selector - аттрибут, добавляем его в случае, если нужно сделать выделение таба, которое с анимацией
     *        передвигается после выделения таба
     *
     * */
    function newTabs(){
        let tabs_active = 'active',
            tabs_content = '.tabs__content';

        $('[data-tabs]').each(function (){
            $(this).selectric({
                maxHeight: 200,
                disableOnMobile: false,
                nativeOnMobile: false,
                responsive: false,
            })
                .prop('selectedIndex', 0).selectric('refresh')
                .on('change', function(){
                    let tabs_parent = $(this).closest('.tabs__parent'),
                        tabs_save = $(this).closest('[data-tabs-save]'),
                        tabs_save_value = tabs_save.data('tabs-save'),
                        tabs_selected = $(this).parents('.selectric-wrapper').find('li.selected'),
                        tab_counter = tabs_selected.index();

                    lazyLoad();

                    tabs_parent.find(tabs_content + ':first').parent().children(tabs_content).removeClass(tabs_active).eq(tab_counter).addClass(tabs_active);

                    // если указан дата аттрибут для сохранения - сохраняем его в localStorage
                    if(tabs_save.length && tabs_save_value.length){
                        localStorage.setItem(tabs_save_value, tab_counter);
                    }

                    // синхронизация двух селектов
                    // в случае сложной адаптивной структуры, если по дизайну селект (табы) переносятся в другой блок
                    $('[data-tabs-sync]').each(function (){
                        $(this).parents('.selectric-wrapper').find('li').removeClass('selected').eq(tab_counter).addClass('selected').trigger('click');
                    })

                    if($(this).closest('[data-tabs-selector]').length){
                        // добавляем координаты и ширину для выделения
                        $(this).closest('[data-tabs-selector]').parents('.selectric-wrapper').find('.tabs__select').css({
                            "left": tabs_selected.position().left + "px",
                            "width": tabs_selected.innerWidth() + "px"
                        });
                    }
                });

            if($(this).closest('[data-tabs-selector]').length){
                // создаём элемент, который будет использоваться как выделение
                let tabs_current = $(this).parents('.selectric-wrapper').find('li.selected');
                $(this).parents('.selectric-wrapper').find('.selectric-scroll').prepend('<span class="tabs__select" style="width: ' + tabs_current.innerWidth() + 'px; left:' + tabs_current.position().left + 'px"></span>');
            }

            // находим общего родителя для табов и контена табов и проставляем классы
            let tabs_parent = $($(this).parents().get().find(itm => $(itm).find(tabs_content).length)),
                tabs_save = $(this).closest('[data-tabs-save]'),
                tabs_save_value = tabs_save.data('tabs-save');

            tabs_parent.addClass('tabs__parent');

            // если установлено сохранение активного таба - при загрузке страницы эмулируем клик на него
            if(tabs_save.length && tabs_save_value.length){
                setTimeout(function() {
                    tabs_save.parents('.selectric-wrapper').find('li:eq(' + localStorage.getItem(tabs_save_value) + ')').trigger('click');
                }, 1);
            }
        });
    }
    newTabs();

    // значение, при котором изменяется тип табов (табы или селект) задается в дата-аттрибут data-tabs-transform
    function tabsTypeCheck(){
        $('[data-tabs-transform]').each(function (){
            let windowWidth = $(this).data('tabs-transform');
            if(WIN.width() <= windowWidth){
                $(this).parents('.select').removeClass('select--tabs').addClass('select--transformed');
            }
            else{
                $(this).parents('.select').addClass('select--tabs').removeClass('select--transformed');
            }
        });
    }
    tabsTypeCheck();

    WIN.on('resize', function() {
        // проверка типа табов
        tabsTypeCheck();
    });
    /** End New tabs **/

    /** Инициализация "маленького" (турниры) select menu валют **/
    $('[data-select-menu-small]').selectric({
        disableOnMobile: false,
        nativeOnMobile: false,
        onInit: function() {
            $(this).parents('.selectric-wrapper').addClass('selectric-wrapper--small');
            if ($(this).find('option').length === 1) {
                $(this).parents('.selectric-wrapper').addClass('selectric--void');
            }
        }
    });
    /** End Инициализация "маленького" select menu валют **/

    /** Инициализация плагина обратного отсчета */
    $('[data-time]').each(function() {
        $(this).countdown($(this).attr('data-time'), function(event) {
            $(this).html(event.strftime('' +
                '<div class="counter__block">' +
                '<span class="counter__value">%D</span>' +
                '<span class="counter__desc">' +
                $(this).attr('data-days') +
                '</span>' +
                '</div>' +
                '<dl>:</dl>' +
                '<div class="counter__block">' +
                '<span class="counter__value">%H</span>' +
                '<span class="counter__desc">' +
                $(this).attr('data-hours') +
                '</span>' +
                '</div>' +
                '<dl>:</dl>' +
                '<div class="counter__block">' +
                '<span class="counter__value">%M</span>' +
                '<span class="counter__desc">' +
                $(this).attr('data-min') +
                '</span>' +
                '</div>' +
                '<dl>:</dl>' +
                '<div class="counter__block">' +
                '<span class="counter__value">%S</span>' +
                '<span class="counter__desc">' +
                $(this).attr('data-sec') +
                '</span>' +
                '</div>'
            ));
        });
    });
    /** End **/

    /** List to Grid view for tables **/
    function viewSwitcherTournament(e) {
        const gridButton = $('[data-view-grid]');
        const listButton = $('[data-view-table]');
        const wrapper = $('.tournament__games');
        listButton.on('click', function() {
            gridButton.removeClass('active');
            listButton.addClass('active');
            wrapper.removeClass('grid').addClass('list');
            $.cookie('TableView', 'table-view', {
                path: '/'
            });
        });
        gridButton.addClass('active');
        gridButton.on('click', function() {
            listButton.removeClass('active');
            gridButton.addClass('active');
            wrapper.removeClass('list').addClass('grid');
            $.cookie('TableView', 'grid-view', {
                path: '/'
            });
        });
    }
    viewSwitcherTournament();

    /** ADD cookies List to Grid view for tables **/
    function setTableView() {
        if ($.cookie('TableView') == null) {
            $.cookie('TableView', 'grid-view', {
                path: '/'
            });
        }
        if ($.cookie('TableView') == 'grid-view') {
            $('[data-view-grid]').click();
        }
        if ($.cookie('TableView') == 'table-view') {
            $('[data-view-table]').click();
        }
    }
    setTableView();
    /** END ADD cookies List to Grid view for tables **/

    /**
     * Закрытие списка языков при клике вне его
     */
    DOC.on('click', function(e){
        if (!$(e.target).closest(".lang").length) {
            $('.lang-select').removeClass('open');
        }
        e.stopPropagation();
    });
});
